define(function () {
    'use strict';

    return function ($http, $cookieStore, $rootScope, Api) {
        return {
            Login: function (username, password, callback) {
                return $http.post(Api.AuthPath, {
                    username: username,
                    password: password,
                    client_id: Api.ClientId,
                    client_secret: Api.ClientSecret,
                    grant_type: 'password'
                }).then(callback, callback);
            },
            Api: Api,
            PublicLogin: function (callback, force) {

                if(this.HasCredentials() && !force)
                    return callback( { status: 200 } );

                return $http.post(Api.AuthPath, {
                    client_id: Api.ClientId,
                    client_secret: Api.ClientSecret,
                    grant_type: 'client_credentials'
                }).then(function(response){
                    let token = response.data.access_token;
                    $http.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                    $rootScope.globals = {Token: token};
                    SetData($rootScope.globals);

                    callback(response);

                }, callback);
            },

            Logout(){
                this.ClearCredentials();
            },

            User: function (callback) {
                return $http.get(Api.Path+"user", {

                }).then(callback, callback);
            },

            HasCredentials: function(){
                if($rootScope.globals.Token)
                    return true;

                return false;
            },

            SetCredentials: function (token, callback) {
                $http.defaults.headers.common['Authorization'] = 'Bearer ' + token;

                this.User(function(response) {
                    if(response.status == "200") {
                        $rootScope.globals = {
                            currentUser: {
                                roles: response.data.roles.map(function(obj){
                                    return obj.replace('ROLE_', '').replace('_', '').toLowerCase();
                                }),
                                id: response.data.id,
                                username: response.data.username,
                                workers: response.data.workers.map(worker => {
                                    return worker.id
                                }),
                                company: response.data.company ? response.data.company.id : null
                            },
                            Token: token
                        };

                        SetData($rootScope.globals);

                        callback();
                    }
                });
            },

            ClearCredentials: function () {
                $rootScope.globals = {};
                RemoveData();
                $http.defaults.headers.common.Authorization = 'Basic';
            }
        }
    }
});


/** WEBPACK FOOTER **
 ** ./js/services/authentication.js
 **/